import LiveClock from 'components/common/LiveClock';
import AccountForm from 'components/type/AddType';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { fetchTypesListPage, typesSelector } from 'slices/typeSlice';

const UpdateAccount = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { typesListPage: types } = useSelector(typesSelector);
    const { id } = useParams();

    useEffect(() => {
        dispatch(fetchTypesListPage());
    }, [dispatch]);

    if (!types.length) return <div>Loading...</div>;

    const item = types.find(t => t.id === Number(id));
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Accounts</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            {item ? <AccountForm item={item} /> : <div>Item not found</div>}
        </div>
    );
};

export default UpdateAccount;
